<template>
  <div v-cloak>
    <transition :name="transitionName" class="po">
      <router-view keep-alive  class="po" />
    </transition>
    <transition name="fade" class="po">
      <spinner v-show='loading' class="loading" :style='screen' message=""></spinner>
    </transition>
  </div> 
</template>

<script>
import Spinner from 'vue-simple-spinner'
import {mapGetters} from 'vuex'
import {nativeBack} from '@/utils/withNative'
export default {
  name: 'App',
  data () {
    return {
      transitionName:'slide-right',
      fingerPosition:{
        startX:0,
        startY:0
      },
      screen:{
        height:(document.querySelector('html').offsetHeight||window.screen.height||window.screen.availHeight||document.body.clientHeight)+'px',
        width:(document.querySelector('html').offsetWidth||window.screen.width||window.screen.availWidth||document.body.clientWidth)+'px'
      },
    }
  },
  mounted(){
     var docEl = document.documentElement;
        var clientWidth = docEl.clientWidth;
        if (!clientWidth) return;
        var div = document.createElement('div');
        div.style.width = '1.4rem';
        div.style.height = '0';
        document.body.appendChild(div);
        var ideal = 140 * clientWidth / 750;
        var rmd = (div.clientWidth / ideal);
        if(navigator.userAgent.indexOf('OPPO')>=0){
          document.getElementsByTagName('HTML')[0].style.width = rmd*100+'%'
          document.getElementsByTagName('BODY')[0].style.width = rmd*100+'%'
        }
        document.body.removeChild(div);
  },
  components:{
    Spinner
  },
  watch: {
    '$route' (to, from) {
      const p = '/progress',root = '/',s ='/students',m='/monthClasses'
      if(from.path === p || from.path === m){
         this.transitionName ='slide-right'
      }else if(from.path === root){
         this.transitionName ='slide-left'
      }else if(from.path === s){
       if(to.path === p || to.path === m){
         this.transitionName ='slide-left'
       }else{
         this.transitionName ='slide-right'
       }
      }
    }
  },
  computed:{
    ...mapGetters([
      'loading'
    ])
  }
}

</script>

<style lang="scss">
@import "styles/common.scss";
[v-cloak] {
  display: none;
}
.po{
  position: absolute;
  top:0;
  right: 0;
  left: 0;
  width:100%;
  min-height:100%;
  background:#F4F5F7;
}

.slide-left-leave-active {
  animation: fadeOutLeft .5s;
}
.slide-left-enter-active {
  animation: fadeInRight .5s;
}
.slide-right-leave-active {
  animation: fadeOutRight .5s;
}
.slide-right-enter-active {
  animation: fadeInLeft .5s;
}
.fade-enter-active{
  animation: fadeIn .5s;
}
.fade-leave-active{
  animation: fadeOut .5s;
}
@keyframes fadeOutRight {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    -webkit-transform: translate3d(100%, 0, 0);
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeOutLeft {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }
}
@keyframes fadeInLeft {
  from {
    opacity: 0;
    -webkit-transform: translate3d(-100%, 0, 0);
    transform: translate3d(-100%, 0, 0);
  }

  to {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeIn{
  from {
    opacity: 0;
    transform: translate3d(0, 0, -100%);
  }

  to {
    opacity: 1;
    transform: none;
  }
}
@keyframes fadeOut{
  from {
    opacity: 1;
    transform: none;
  }

  to {
    opacity: 0;
    transform: none;
    transform: translate3d(0, 0, -100%);
  }
}

</style>



// WEBPACK FOOTER //
// src/App.vue